// ─────────────────────────────────────────────────────────────────────────────
// 🔑 THE BORROWER APP'S ONE PAGE CONTAINER (Hannah's production review, 2026-11-03). AppShell wraps EVERY borrower page in
// it — Dashboard, Documents, Homes, Schedule, Messages, Alerts, Settings and the rest — on desktop, tablet and phone:
//   · the same max width: BORROWER_COLUMN_MAX (1400px, DoorlyDesk's content width), centred in the main column;
//   · the same side gutter: BORROWER_GUTTER_CLASS (16px phone, 24px from 640px up);
//   · the same top spacing: BORROWER_PAGE_TOP_PX, so each page's title starts at the same x and y.
// A page never centres or pads itself inside it; narrower content (Settings, Alerts, Schedule) keeps its own max width
// and stays LEFT-aligned. backend/test/borrowerPageContainer.test.js walks the routes and holds every page to this.
// ─────────────────────────────────────────────────────────────────────────────
import React from 'react';
import { borrowerColumn, BORROWER_GUTTER_CLASS, BORROWER_PAGE_TOP_PX } from '../constants/guidedLayout';

export function BorrowerPageContainer({ children }) {
  return (
    <div className={BORROWER_GUTTER_CLASS}>
      <div data-testid="borrower-page-container" style={{ ...borrowerColumn, paddingTop: BORROWER_PAGE_TOP_PX }}>
        {children}
      </div>
    </div>
  );
}

export default BorrowerPageContainer;
